import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/Nikola-Logo1-01.svg'


const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex h-16 items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: _imports_0,
    alt: "Your Company"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:flex sm:items-center sm:ml-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-4 mx-auto" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "rounded-md bg-gray-900 px-3 py-2 text-sm font-medium text-white"
    }, "Home"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#About",
      class: "rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
    }, "About Us"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#Pricing",
      class: "rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
    }, "Prices"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#Contact",
      class: "rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
    }, "Contact Us")
  ])
], -1)
const _hoisted_5 = { class: "-mr-2 flex sm:hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-0.5" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_8 = { class: "space-y-1 px-2 pb-3 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createBlock(_component_Disclosure, {
    as: "nav",
    class: "header z-50 fixed min-w-full bg-gray-900"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DisclosureButton, { class: "relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                (!open)
                  ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                      key: 0,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_component_XMarkIcon, {
                      key: 1,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _createVNode(_component_DisclosurePanel, { class: "sm:hidden" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DisclosureButton, {
                as: "a",
                href: "#",
                class: "block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              }),
              _createVNode(_component_DisclosureButton, {
                as: "a",
                href: "#About",
                class: "block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("About Us")
                ]),
                _: 1
              }),
              _createVNode(_component_DisclosureButton, {
                as: "a",
                href: "#Pricing",
                class: "block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Prices")
                ]),
                _: 1
              }),
              _createVNode(_component_DisclosureButton, {
                as: "a",
                href: "#Contact",
                class: "block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Contact Us")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}